export default __webpack_public_path__ + "static/media/validador.fad869d9.svg";